/* eslint-disable */
import {
  Badge,
  HStack,
  IconButton,
  Stack,
  Switch,
  Text,
  Tooltip
} from "@chakra-ui/react";
import * as React from "react";
// Custom components

// Assets

import {
  createColumnHelper
} from "@tanstack/react-table";
import { useDispatch, useSelector } from "react-redux";
import {
  selectButtonLoading,
  selectList,
  selectLoading,
  selectOrderBy,
  selectOrderDir,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectTotalRow,
} from "./redux/selector";

import { EditIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DateFormat from "../../../components/Common/DateFormat";
import { CommonTable } from "../../../components/CommonTable";
import { DataActiveStatusEnum } from "../Category/types";
import { actions } from "./redux/slice";
import { IData } from "./types";

export default function Index() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const search = useSelector(selectSearch);
  const tableData = useSelector(selectList);
  const loading = useSelector(selectLoading);
  const total = useSelector(selectTotalRow);
  const orderBy = useSelector(selectOrderBy);
  const orderDir = useSelector(selectOrderDir);
  const buttonLoading = useSelector(selectButtonLoading);
  const [selectedIndex, setSelectedIndex] = React.useState<number | null>(null);

  React.useEffect(() => {
    dispatch(actions.doGetList());
    return () => {};
  }, [pageNo, pageSize, search, orderDir, orderBy]);

  const handleUpdateStatus = (id: string, index: number) => {
    setSelectedIndex(index);
    dispatch(
      actions.doUpdateStatus({
        id: id,
        index: index,
        callback() {
          setSelectedIndex(null);
          dispatch(actions.doGetList());
        },
      })
    );
  };

  const columnHelper = createColumnHelper<IData>();
  const columns = [
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.sNo")}`,
      cell: (info) => {
        return (
          <>
            {pageNo === 1 ? (
              <>{info.row.index + 1}</>
            ) : (
              <>{`${(pageNo - 1) * pageSize + info.row.index + 1}`}</>
            )}
          </>
        );
      },
    }),
    columnHelper.accessor("title", {
      id: "title",
      header: `${t("common.list.title")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("price", {
      id: "price",
      header: `${t("common.list.price")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("taxRate", {
      id: "taxRate",
      header: `${t("common.list.taxRate")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("subCategoryTitle", {
      id: "subCategoryTitle",
      header: `${t("common.list.subCategory")}`,
      cell: (info) => <Text>{info.getValue() || "NA"}</Text>,
    }),
    columnHelper.accessor("status", {
      id: "status",
      header: `${t("common.list.status")}`,
      cell: (info) => (
        <Badge
          colorScheme={
            info.getValue() === DataActiveStatusEnum.ACTIVE ? "green" : "red"
          }
          color={
            info.getValue() === DataActiveStatusEnum.ACTIVE
              ? "green.500"
              : "red.500"
          }
          fontSize="md"
          fontWeight="500"
          sx={{ textTransform: "capitalCase" }}
        >
          {info.row.original.status}
        </Badge>
      ),
    }),

    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: `${t("common.list.createdAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
       sortDescFirst: true,
    }),
    columnHelper.accessor("updatedAt", {
      id: "updatedAt",
      header: `${t("common.list.updatedAt")}`,
      cell: (info) => <Text>{DateFormat(info.getValue()) || "NA"}</Text>,
    }),

    columnHelper.accessor("status", {
      id: "status",
      header: `${t("common.list.updateStatus")}`,

      cell: (info) => (
        <Stack>
          <Switch
            disabled={
              (info.row.index === selectedIndex && buttonLoading) ||
              info.row.original.status == DataActiveStatusEnum.INACTIVE
            }
            colorScheme={
              info.getValue() === DataActiveStatusEnum.ACTIVE ? "green" : "red"
            }
            color={
              info.getValue() === DataActiveStatusEnum.ACTIVE
                ? "green.500"
                : "red.500"
            }
            checked={
              info.row.original.status == DataActiveStatusEnum.ACTIVE
                ? true
                : false
            }
            defaultChecked={
              info?.row?.original?.status == DataActiveStatusEnum.ACTIVE
                ? true
                : false
            }
            onChange={() => {
              handleUpdateStatus(info.row.original._id, info.row.index);
            }}
          />
        </Stack>
      ),
    }),
    columnHelper.accessor("_id", {
      id: "_id",
      header: `${t("common.list.actions")}`,
      cell: (info) => {
        return (
          <HStack>
            <Tooltip label={`${t("common.list.edit")}`}>
              <IconButton
                aria-label="Edit"
                icon={<EditIcon />}
                onClick={() => {
                  navigate(`/admin/package/create/${info.row.original._id}`);
                }}
              />
            </Tooltip>
          </HStack>
        );
      },
    }),
  ];
  const handleAddNew = () => {
    dispatch(actions.setSearch(""));
    navigate("/admin/package/create");
    dispatch(actions.clearFrom());
  };
  return (
    <>
      <CommonTable<IData>
        columns={columns}
        data={tableData}
        totalCount={total}
        pageNo={pageNo}
        pageSize={pageSize}
        search={search}
        loading={loading}
        onSearch={(v) => dispatch(actions.setSearch(v))}
        onPageChange={(p) => dispatch(actions.setPageNo(p))}
        onPageSizeChange={(s) => dispatch(actions.setPageSize(s))}
        onSortChange={(id, desc) => {
          dispatch(actions.setOrderBy(id));
          dispatch(actions.setOrderDir(desc ? "desc" : "asc"));
        }}
        handleAddNew={handleAddNew}
      />
    </>
  );
}
